import { Box, Container } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { toggleFormEditResources } from '../../../../../redux/actions/resources'
import { IRootState } from '../../../../../redux/types'
import FeaturedDetail from '../../../../frontoffice/library/ui/components/FeaturedDetail'
import useDetailActions from '../../../../frontoffice/library/ui/hooks/useDetailActions'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import DetailHeroPanel from '../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import useDetailInitialState from '../../../../shared/hooks/library/useDetailInitialState'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import AdminDetailInfo from '../components/AdminDetailInfo'
import ResourceModal from '../components/ResourceModal'
import TypeFileView from '../components/TypeFileView'

function ResourceDetail() {
  const { t } = useTranslation(['global'])
  const location = useLocation()
  const isMobile = useScreenWidth(700)
  const dispatch = useDispatch()

  const { resourceSelected, showEditForm } = useSelector((state: IRootState) => state.resource)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  const { favoriteState, setFavoriteState, infoDetail } = useDetailInitialState()
  const { hasDescription, msgCopy, handleCopyText, handleFavorite, handleDownload } = useDetailActions(setFavoriteState)

  return (
    <div>
      {resourceSelected?.view && (
        <Container maxWidth="xl">
          {showEditForm && <ResourceModal />}

          <ButtonBack />

          <Grid container spacing={5}>
            <Grid xs={12} md={8}>
              <VerifyAccessRoute visibility={resourceSelected.visibility} />

              {location.pathname.includes('admin') && <AdminDetailInfo resourceSelected={resourceSelected} />}

              <Box mt={isMobile ? 1 : 3}>
                <TypeFileView file={resourceSelected} type={'resources'} />
              </Box>
              {resourceSelected.resourcetype_id === 4 &&
                userBrands !== null &&
                userBrands.find((brand: any) => brand.id === resourceSelected.brand_id)?.highlight === 1 && <FeaturedDetail />}
            </Grid>
            <Grid xs={12} md={4}>
              <DetailHeroPanel
                visibility={resourceSelected.visibility}
                brand={resourceSelected?.brand?.name}
                title={resourceSelected.alias}
                author={null}
                description={resourceSelected.description}
                edit={() => {
                  dispatch(toggleFormEditResources())
                }}
                download={() => handleDownload(resourceSelected.id)}
                hasDescription={hasDescription}
                copyDescription={() => {
                  handleCopyText()
                }}
                onClickFavorite={handleFavorite(resourceSelected.id)}
                favoriteState={favoriteState}
                share={
                  <ShareIcon
                    meta={true}
                    visibility={resourceSelected.visibility}
                    title={resourceSelected.alias || resourceSelected.file_name}
                    description={resourceSelected.description || ''}
                    link={window.location.href}
                    multimedia={`${import.meta.env.VITE_AWS_URL}/resources/webp/${resourceSelected.cover ?? resourceSelected.file_name}`}
                    multimediaType={resourceSelected.ext === 'mp4' ? 'video' : 'image'}
                    type="resource"
                    component="buttonTextGreen"
                    buttonTextGreen={t('share')}
                  />
                }
              />
              <DetailInfoPanel attributes={infoDetail} />
            </Grid>
          </Grid>

          <CustomSnackBar errors={[false]} msgs={[msgCopy]} />
        </Container>
      )}
    </div>
  )
}

export default ResourceDetail
